import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Schedule" mdxType="SEO" />
    <h2>{`Schedule`}</h2>
    <p>{`This page lists guests that are scheduled to appear on the Lex Fridman Podcast. The information has been collected from Lex's social media statuses (primarily Twitter and Reddit).`}</p>
    <h3>{`Upcoming guests`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/GMHikaru"
        }}>{`Hikaru Nakamura`}</a>{` - Chess Grandmaster`}</li>
    </ul>
    <h3>{`Archive (Released)`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://facebook.com/zuck"
        }}>{`Mark Zuckerberg`}</a>{` - CEO of Meta`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.jordanbpeterson.com"
        }}>{`Jordan Peterson`}</a>{` - Clinical psychologist, author`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/AlbertBourla"
        }}>{`Albert Bourla`}</a>{` - CEO of Pfizer`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/elonmusk"
        }}>{`Elon Musk`}</a>{` - CEO of SpaceX and Tesla`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/nealstephenson"
        }}>{`Neal Stephenson`}</a>{` - Novelist, short story writer, essayist`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/VitalikButerin"
        }}>{`Vitalik Buterin`}</a>{` - Co-founder of Ethereum`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/HardcoreHistory"
        }}>{`Dan Carlin`}</a>{` - Political commentator, podcaster`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      